import React, { useState, useEffect, useRef } from "react";
import ShowCard from "../../Components/ShowCard/ShowCard";
import * as service from "./service";
import { useSelector} from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import Loading from "../../Components/Loading/Loading";
import { rowItemCount } from "../../utils/utils";
import { useWindowWidth } from "@react-hook/window-size";
import { ReactComponent as FilterIcon } from "../../assets/Icons/filter.svg";
import { ReactComponent as ChevronIcon } from "../../assets/Icons/chevron-down.svg";
import useScrollPosition from "../../Components/ScrollPosition/useScrollPosition";
import ShortsCard from "../Shorts/ShortsCard";
import Translate, { useTranslateText } from "../../Components/Multilanguage/Translate";

const Search = () => {
  const accessToken = useSelector((state) => state.accessToken?.value);
  const projectInfo = useSelector((state) => state?.projectInfo?.value);
  const translateText = useTranslateText();

  const [searchData, setSearchData] = useState([]);
  const [searchInput, setSearchInput] = useState();
  const [loading, setLoading] = useState(true);
  const [rowItemsClass,setRowItemsClass] = useState("")
  const [sliceCount,setSliceCount] = useState(20)
  const [searchDataCategories, setSearchDataCategories] = useState([]);
  const [activeCategory, setActiveCategory] = useState();
  const [thumbnailOrientation, setThumbnailOrientation] = useState();
  const [filterData, setFilterData] = useState([]);
  const [showFilters, setShowFilters] = useState(true);
  const [selectedFilters, setSelectedFilters] = useState([]);
  const [fetching, setFetching] = useState(false);
  
  const location = useLocation();
  const params = new URLSearchParams(location?.search);
  const windowSize = useWindowWidth()
  const containerRef = useRef(null)
  const scrollPosition = useScrollPosition();
  const template = projectInfo?.projectConfig?.config?.TEMPLATE;
  const theme = projectInfo?.projectConfig?.config?.THEME;
  const filterRequired = projectInfo?.projectConfig?.config?.CUSTOM_FILTERS_REQUIRED;
  const navigate = useNavigate();


  let query = params?.get("query");

  const appInfo = {
    accessToken: accessToken,
    projectDetails: projectInfo,
  };

  useEffect(()=>{
    if(!loading && sliceCount<searchData?.length){
      lazyLoad()
    }
  },[loading,scrollPosition,searchData])

  useEffect(() => {
    if(windowSize>980){
      if(projectInfo?.projectConfig?.config?.WEBSITE_ROW_ITEM_COUNT){
        setRowItemsClass(rowItemCount(projectInfo?.projectConfig?.config?.WEBSITE_ROW_ITEM_COUNT))
      }else{
        setRowItemsClass("rowCount4")
      }
    }else{
      setRowItemsClass("")
    }
  }, [projectInfo,windowSize]);

  useEffect(() => {
    if (filterRequired === "true") {
      fetchFilterData();
    }
  }, [filterRequired]);

  useEffect(() => {
    window.scroll(0,0)
    setFetching(true);
    if (filterRequired === "true") {
      if (query === null && selectedFilters.length === 0) {
        setSearchInput(null);
      } else {
        setSearchInput(query);
      }
      fetchShowDetailsWithFilters();
    } else {
      setLoading(true);
      if (query === null) {
        setSearchInput(null);
      } else {
        setSearchInput(query);
      }
      fetchShowDetails();
    }
  }, [query, selectedFilters, filterRequired]);

  const fetchFilterData = async () => {
    try {
      const response = await service.getSearchFilters(appInfo);
      if (response?.status === 200) {
        setFilterData(response?.data?.data);
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || <Translate textKey={'filter_fail_message'} />, {
        position: "bottom-center",
      });
    }
  };
 
   const fetchShowDetailsWithFilters = async () => {
    try {
      setSearchData();
      setSearchDataCategories();
      let requestParams = {};
      if (query) {
        requestParams.key = query;
      }
      const activeFilters = selectedFilters.filter(filter => filter.option_id !== "");
      if (activeFilters.length > 0) {
        requestParams.filters = activeFilters?.map(filter => ({
          filter_id: filter.filter_id,
          option_id: filter.option_id
        }));
      }
      const response = await service.getShows(appInfo, requestParams);
      if (response?.status === 200) {
        if (response?.data?.data[0]?.category_id) {
          setSearchData(response?.data?.data[0]?.shows);
          setSearchDataCategories(response?.data?.data);
          setThumbnailOrientation(response?.data?.data[0]?.thumbnail_orientation || projectInfo?.projectConfig?.config?.THUMBNAIL_ORIENTATION)
        } else {
          setSearchData(response?.data?.data);
        }
        setActiveCategory(response?.data?.data[0]?.category_name)
        setLoading(false);
        setFetching(false);
      } else {
        setLoading(false);
        setFetching(false);
      }
    } catch (err) {
      setLoading(false);
      setFetching(false);
      toast.error(err?.response?.data?.message, {
        position: "bottom-center",
      });
    }
  }

  const fetchShowDetails = async()=>{
    try{
      setSearchData();
      setSearchDataCategories();
      const response = await service?.getShows(appInfo, query,location?.state?.type);
      if (response?.status === 200) {
          if(response?.data?.data[0]?.category_id){
            setSearchData(response?.data?.data[0]?.shows);
            setSearchDataCategories(response?.data?.data);
            setThumbnailOrientation(response?.data?.data[0]?.thumbnail_orientation || projectInfo?.projectConfig?.config?.THUMBNAIL_ORIENTATION)
          }
          else{
            setSearchData(response?.data?.data); 
          }
      setActiveCategory(response?.data?.data[0]?.category_name)
      setLoading(false);
      setFetching(false);
    } else {
      setLoading(false);
      setFetching(false);
    }
    }catch(err){
      setLoading(false);
      setFetching(false);
      toast.error(err?.response?.data?.message, {
        position: "bottom-center",
      });
    }
    
  }

  const lazyLoad = () => {
    const containerHeight = containerRef?.current?.clientHeight;
    if(scrollPosition + 2200 >= containerHeight){
      setSliceCount(sliceCount+20)
    }
  }
    const searchCategoryHandler = (item) => { 
    setFetching(true);
    setSearchData(null);
    setTimeout(() => {
      setSearchData(item?.shows);
      setActiveCategory(item?.category_name);
      setFetching(false);
    }, 100);
  }

  const filterButtonText = selectedFilters.length > 0
    ? <Translate textKey={'remove_filter'} />
    : (showFilters ? <Translate textKey={'close_filter'} /> : <Translate textKey={'show_filter'} />);

  const handleFilterButtonClick = () => {
    if (selectedFilters.length > 0) {
      clearAllFilters();
    } else {
      setShowFilters((prev) => !prev);
    }
  };

  const handleDropdownChange = (filterId, optionId, optionTitle) => {
    const existingFilterIndex = selectedFilters.findIndex(
      (filter) => filter.filter_id === filterId
    );

    if (optionId === "") {
      if (existingFilterIndex > -1) {
        const updatedFilters = [...selectedFilters];
        updatedFilters.splice(existingFilterIndex, 1);
        setSelectedFilters(updatedFilters);
      }
      return;
    }

    if (existingFilterIndex > -1) {
      const updatedFilters = [...selectedFilters];
      updatedFilters[existingFilterIndex] = {
        filter_id: filterId,
        option_id: optionId,
        title: optionTitle,
      };
      setSelectedFilters(updatedFilters);
    } else {
      setSelectedFilters([
        ...selectedFilters,
        { filter_id: filterId, option_id: optionId, title: optionTitle },
      ]);
    }
  };

  const clearAllFilters = () => {
    setSelectedFilters([]);
  };

    const CustomDropdown = ({ label, options, selectedValue, onChange, allLabel = translateText("all") }) => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    useEffect(() => {
      const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
          setIsOpen(false);
        }
      };
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, []);

    const handleDropdownClick = (e) => {
      if (e.target.closest('.dropdown-menu')) return;
      setIsOpen((prev) => !prev);
    };

    const handleSelect = (option, e) => {
      if (e) e.stopPropagation();
      onChange(option.value);
      setIsOpen(false);
    };

    let selectedLabel = allLabel;
    if (selectedValue !== "") {
      const selectedOption = options.find(opt => opt.value === selectedValue);
      if (selectedOption) selectedLabel = selectedOption.label;
    }

    return (
      <div
        className={`custom-dropdown ${selectedValue !== '' ? "active" : ""}`}
        ref={dropdownRef}
        onClick={handleDropdownClick}
      >
        <div className={`dropdown-selector ${isOpen ? 'active' : ''}`}> 
          <span className="selected-value">
            {label ? `${label}: ${selectedLabel}` : selectedLabel}
          </span>
          <ChevronIcon className={`chevron-icon ${isOpen ? 'open' : ''}`} />
        </div>
        {isOpen && (
          <div className="dropdown-menu">
            <div
              className={`dropdown-item ${selectedValue === "" ? "selected" : ""}`}
              onClick={(e) => handleSelect({ value: "", label: allLabel }, e)}
            >
              {allLabel}
            </div>
            {options?.map((option) => (
              <div
                key={option.value}
                className={`dropdown-item ${selectedValue === option.value ? "selected" : ""}`}
                onClick={(e) => handleSelect(option, e)}
              >
                {option.label}
              </div>
            ))}
          </div>
        )}
      </div>
    );
  };

  if(loading){
    return(
      <Loading/>
    )
  }

  return (
    <div className="searchPage" ref={containerRef}>
      <ToastContainer />
      <div className="wrapper">
        <div className="top">
          {searchInput && (
            <h1 className="heading"><Translate textKey={'results_for'}/> "{searchInput}"</h1>
          )}
          {filterRequired === "true" && (
            <div className="filters-container">
              <div className="filters-header">
                <button className="filter-toggle" onClick={handleFilterButtonClick}>
                  <FilterIcon />
                  <span>{filterButtonText}</span>
                </button>
              </div>
              
              {showFilters && (
                <div className="filters-content">
                  <div className="filters-grid">
                    {filterData?.map((filter) => (
                      <CustomDropdown
                        key={filter.filter_id}
                        label={filter.filter_title}
                        selectedValue={
                          selectedFilters.find((f) => f.filter_id === filter.filter_id)?.option_id || ''
                        }
                        options={filter.options?.map(option => ({
                          value: option.option_id,
                          label: option.title
                        }))}
                        onChange={(value) => {
                          const option = filter.options.find(
                            (opt) => opt.option_id === value
                          );
                          handleDropdownChange(
                            filter.filter_id,
                            value,
                            option ? option.title : <Translate textKey={'all'} />
                          );
                        }}
                        allLabel={translateText("all")}
                      />
                    ))}
                  </div>
                    {/* {selectedFilters.length > 0 && (
                    <div className="active-filters">
                      {selectedFilters.map((filter, index) => (
                        <div className="filter-tag" key={index}>
                          <span className="filter-name">
                            {filterData.find(f => f.filter_id === filter.filter_id)?.filter_title}:
                          </span>
                          <span>{filter.title}</span>
                          <div 
                            className="filter-remove" 
                            onClick={() => handleDropdownChange(filter.filter_id, "", "")}
                            title="Remove filter"
                          ></div>
                        </div>
                      ))}
                    </div>
                  )} */}
                </div>
              )}
            </div>
          )}
        </div>
        <div className="bottom">
          <div className="categories">
            {
              searchDataCategories?.map((item,index)=>(
                <button 
                className={
                  activeCategory === item?.category_name 
                    ? (template === "TEMPLATE_10" ? "gaia-active" : (theme === "LIGHT"? "active-light":"active")) 
                    : (template === "TEMPLATE_10" ? "gaia-categoryButton" : (theme === "LIGHT"? "category-light":"categoryButton"))
                } 
                key={index} 
                onClick={() => searchCategoryHandler(item)}
              >
                {item?.category_name}
              </button>
              ))
            }
          </div>
          <div className="itemsContainer">
            {fetching ? (
              <h1
                style={{
                  display: "flex",
                  justifyContent: "center",
                }}
              >
               <Translate textKey={'loading'} />
              </h1>
            ) : (!searchData || searchData.length === 0) && (
              <h1
                style={{
                  color: "#E72A31",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
               <Translate textKey={'no_data_found'} />
              </h1>
            )}
            {searchData && searchData.slice(0, sliceCount)?.map((item, index) => (
              item?.type === "SHORTS" ? (
                <div
                  className={"shortsContainer" }
                  key={index} 
                >
                  <ShortsCard 
                    data={item}
                    season={false}
                    metaData={true}
                    type={item?.type}
                    vanityUrl={item?.vanity_url}
                          />
                </div>
              ) : (
                <div
                  className={
                    (thumbnailOrientation || projectInfo?.projectConfig?.config?.THUMBNAIL_ORIENTATION) === "PORTRAIT"
                      ? `items portrait ${rowItemsClass}`
                      : `items landscape ${rowItemsClass}`
                  }
                  key={index}
                >
                  {(<ShowCard
                    data={item}
                    imageUrl={true}
                    season={false}
                    metaData={true}
                    modalNavigation={true}
                    thumbnailOrientation={thumbnailOrientation}
                    playlist={item?.type === "SHOW"}
                  />) }
                </div>
              )
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Search;